window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');

    require('jquery-validation/dist/jquery.validate.min');

    //require('bootstrap');
    require('@coreui/coreui');

    require('inputmask/dist/jquery.inputmask');;
    require('jquery-toast-plugin/dist/jquery.toast.min');



    window.jQuery(document).ready(function(){

        // $('.m_tel').inputmask({ mask: ["(99) 9999-9999", "(99) 99999-9999" ], greedy: false });
        // $('.m_cel').inputmask("(99) 99999-9999");
        // $('.m_cep').inputmask("99999-999");
        // $('.m_cnpj').inputmask("99.999.999/9999-99");
        // $('.m_cpf').inputmask("999.999.999-99");
        // $('.m_date').inputmask("99/99/9999");
        // $('.m_datetime').inputmask("99/99/9999 99:99");
        // $('.m_monthYear').inputmask("99/9999");

        // Mask para cpf/cnpj/email
        // $('.m_username').inputmask({ mask: ["999.999.999-99", "99.999.999/9999-99"], greedy: false });

        // $('[data-toggle="tooltip"]').tooltip();

        $('.js-btnExcluirRegistro').click(function(){
            return confirm('Deseja realmente excluir esse registro ?');
        });

        $('.js-btnConfirmaAcao').click(function(){
            return confirm('Deseja realmente executar essa ação ?');
        });
    });


} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo';

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });
